// extracted by mini-css-extract-plugin
export default {"box":"Alert_box__ML5mu","fail":"Alert_fail__z74p1","left":"Alert_left__4V6Cp","text":"Alert_text__wVoXY","btn":"Alert_btn__wtrAg","closeIcon":"Alert_closeIcon__s86S2"};